const initialState = {
  ui: {
    suggestionsModalOpened: false,
    suggestionsDiscardReasonsModalOpened: false,
  },
  recurringOrderSuggestion: null,
};

const initialStateForTest = {
  ui: {
    suggestionsModalOpenned: false,
    suggestionsDiscardReasonsModalOpened: false,
  },
  recurringOrderSuggestion: null,
};

export default initialState;
export { initialStateForTest };
